var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.templates),function(template){return _c('TemplatesListItem',{key:template.id,attrs:{"template":template},on:{"delete-template":function($event){return _vm.$emit('delete-template', template.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }